import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { useState, useEffect } from "react";

// Import react-bootstrap components
import { Tab, Tabs, Container, Navbar, Nav, Button } from "react-bootstrap";

import LoginScreen from "./components/LoginScreen";
import ManagerScreen from "./components/ManagerScreen";
import ProviderScreen from "./components/ProviderScreen";
import UserScreen from "./components/UserScreen";

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const [key, setKey] = useState("booking");

  useEffect(() => {
    document.title = "UpHealth Administration";
    if (localStorage.getItem("@uphealth_login_token") !== null) {
      setIsLogin(true);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("@uphealth_login_token");
    setIsLogin(false);
  };

  // If not logged in, show the full-page login screen
  if (!isLogin) {
    return <LoginScreen setIsLogin={setIsLogin} />;
  }

  // If logged in, show the dashboard
  return (
    <div className="App">
      {/* New Header Navbar */}
      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        sticky="top"
        className="shadow-sm"
      >
        <Container fluid>
          <Navbar.Brand href="#home">
            <img
              src={require("./assets/icon-uphealth.png")}
              width="30"
              height="30"
              className="d-inline-block align-top me-2"
              alt="UpHealth logo"
            />
            UpHealth Administration
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <Button variant="outline-danger" onClick={handleLogout}>
                Logout
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content Area */}
      <Container fluid className="mt-3">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
          fill
        >
          <Tab eventKey="booking" title="Booking">
            {/* Removed unused setIsLogin prop */}
            <ManagerScreen />
          </Tab>
          <Tab eventKey="provider" title="Provider">
            <ProviderScreen />
          </Tab>
          <Tab eventKey="user" title="User">
            <UserScreen />
          </Tab>
        </Tabs>
      </Container>
    </div>
  );
}

export default App;
